export enum ActionsOrActionTypesContext {
  ACTION = "action",
  ACTION_TYPES = "actionTypes",
}
